
// vue
import { defineComponent } from 'vue';

// shared
import shared from './shared';

// types
import { Props, Context } from '../../types';

export default defineComponent({
    setup(props: Props, context: Context) {
    
        return {
            ...shared(props, context),
        };
    },
});
